import React from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, Wifi, FileText, CreditCard, Settings, Router, LogOut, Shield, BarChart3 } from 'lucide-react';

const menuItems = [
  { path: '/', icon: LayoutDashboard, label: 'Dashboard', roles: ['admin', 'operador', 'tecnico'] },
  { path: '/clientes', icon: Users, label: 'Clientes', roles: ['admin', 'operador', 'tecnico'] },
  { path: '/planes', icon: Wifi, label: 'Planes', roles: ['admin', 'operador'] },
  { path: '/facturas', icon: FileText, label: 'Facturas', roles: ['admin', 'operador'] },
  { path: '/pagos', icon: CreditCard, label: 'Pagos', roles: ['admin', 'operador'] },
  { path: '/mikrotik', icon: Router, label: 'MikroTik', roles: ['admin', 'tecnico'] },
  { path: '/reportes', icon: BarChart3, label: 'Reportes', roles: ['admin', 'operador'] },
  { path: '/configuracion', icon: Settings, label: 'Configuracion', roles: ['admin'] },
];

export default function Layout() {
  const location = useLocation();
  const navigate = useNavigate();

  const userStr = localStorage.getItem('user');
  const user = userStr ? JSON.parse(userStr) : null;
  const rol = user?.rol || 'admin';

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const menuFiltrado = menuItems.filter(item => item.roles.includes(rol));

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <aside className="w-64 bg-white shadow-lg flex flex-col">
        <div className="p-6 border-b">
          <h1 className="text-2xl font-bold text-primary-600">PilarNet</h1>
          <p className="text-sm text-gray-500">Sistema ISP</p>
          {user && (
            <div className="mt-3 pt-3 border-t">
              <p className="text-sm font-medium text-gray-900">{user.nombre}</p>
              <div className="flex items-center space-x-1 mt-1">
                <Shield size={12} className={`${
                  rol === 'admin' ? 'text-purple-600' :
                  rol === 'operador' ? 'text-blue-600' :
                  'text-gray-600'
                }`} />
                <span className={`text-xs font-medium capitalize ${
                  rol === 'admin' ? 'text-purple-600' :
                  rol === 'operador' ? 'text-blue-600' :
                  'text-gray-600'
                }`}>
                  {rol}
                </span>
              </div>
            </div>
          )}
        </div>
        <nav className="p-4 space-y-2 flex-1 overflow-y-auto">
          {menuFiltrado.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                  isActive
                    ? 'bg-primary-50 text-primary-600'
                    : 'text-gray-600 hover:bg-gray-50'
                }`}>
                <Icon size={20} />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>
        <div className="p-4 border-t bg-white">
          <button
            onClick={handleLogout}
            className="flex items-center space-x-3 px-4 py-3 w-full text-gray-600 hover:bg-gray-50 rounded-lg">
            <LogOut size={20} />
            <span>Cerrar Sesion</span>
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto">
        <div className="p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
